export const addOptionToSelection = (selectedOptions, option) => {
  if (selectedOptions.some((selectedOption) => selectedOption.id === option.id)) {
    return selectedOptions;
  }
  return [...selectedOptions, option];
};

export const removeSelectedOptionById = (selectedOptions, id) => {
  return selectedOptions.filter((option) => option.id !== id);
};

export const checkGroupItems = (group, checked, selectedOptions, checkElement) => {
  let newSelection = selectedOptions;

  group.forEach((child) => {
    checkElement(child.id, checked);

    if (checked) {
      newSelection = addOptionToSelection(newSelection, child);
    } else {
      newSelection = removeSelectedOptionById(newSelection, child.id);
    }

    if (child.children) {
      newSelection = checkGroupItems(child.children, checked, newSelection, checkElement);
    }
  });

  return newSelection;
};

export const checkGroup = (groupId, flatOptions, selectedOptions, checkElement) => {
  const groupOption = flatOptions.find((option) => option.id === groupId);
  if (!groupOption?.isSelectable) {
    return selectedOptions;
  }

  const selectedIds = new Set(selectedOptions.map((option) => option.id));
  const groupChildrenIds = groupOption.children.map((child) => child.id);
  const allChecked = groupChildrenIds.every((childId) => selectedIds.has(childId));

  checkElement(groupId, allChecked);

  let newSelection = allChecked
    ? addOptionToSelection(selectedOptions, groupOption)
    : removeSelectedOptionById(selectedOptions, groupOption.id);

  if (allChecked && groupOption.group) {
    newSelection = checkGroup(groupOption.group, flatOptions, newSelection, checkElement);
  }

  return newSelection;
};
